import { Injectable } from "@angular/core";
import { IVariantService } from "./variant";

@Injectable({
	providedIn: "root",
})
export class VariantService implements IVariantService {
	readonly variant = "base";
	readonly isHxaDevices = false;
}
